<template>
  <div class="page-container">
    <div class="page-header">
      <h1 class="page-title">官網 SEO 設定</h1>
      <button class="btn btn-secondary" :disabled="syncing" @click="syncRegistry">
        {{ syncing ? '同步中…' : '同步頁面清單' }}
      </button>
    </div>

    <div class="page-toolbar">
      <div class="search-box">
        <input v-model="search" type="text" class="form-control" placeholder="搜尋 path / title…" />
        <i class="ri-search-line"></i>
      </div>
    </div>

    <div v-if="loading" class="loading-state"><div class="spinner" /><p>載入中...</p></div>
    <div v-else-if="error" class="error-state">
      <p>{{ error }}</p>
      <button class="btn btn-secondary" @click="fetchList">重試</button>
    </div>
    <div v-else class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Path</th>
            <th>Title</th>
            <th>更新時間</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filtered.length === 0">
            <td colspan="4" class="empty-state">尚無 SEO 資料，請先同步頁面清單</td>
          </tr>
          <tr v-for="item in filtered" :key="item.pageKey">
            <td><code>{{ item.path }}</code></td>
            <td class="col-title">{{ item.title }}</td>
            <td>{{ formatDate(item.updatedAt) }}</td>
            <td>
              <router-link
                class="btn-action"
                title="編輯"
                :to="{ name: 'WebsiteSeoEdit', params: { pageKey: item.pageKey } }"
              >
                <i class="ri-edit-line"></i>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { websiteSeoService } from '@/api/modules/website.js'
import { showSuccess, showError } from '@/utils/swal.js'

export default {
  name: 'WebsiteSeoIndex',
  data() {
    return {
      loading: false,
      syncing: false,
      error: '',
      search: '',
      items: [],
    }
  },
  computed: {
    filtered() {
      const q = this.search.trim().toLowerCase()
      if (!q) return this.items
      return this.items.filter(
        (i) =>
          (i.path || '').toLowerCase().includes(q) ||
          (i.title || '').toLowerCase().includes(q) ||
          (i.pageKey || '').toLowerCase().includes(q)
      )
    },
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    formatDate(v) {
      if (!v) return '—'
      return new Date(v).toLocaleString('zh-TW')
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const res = await websiteSeoService.list()
        this.items = res?.data?.items || []
      } catch (e) {
        this.error = e?.response?.data?.message || '載入失敗'
      } finally {
        this.loading = false
      }
    },
    async syncRegistry() {
      this.syncing = true
      try {
        await websiteSeoService.syncRegistry()
        showSuccess('已同步頁面清單')
        await this.fetchList()
      } catch (e) {
        showError(e?.response?.data?.message || '同步失敗')
      } finally {
        this.syncing = false
      }
    },
  },
}
</script>

<style scoped>
@import '~@/assets/scss/components/_list-page-common.scss';

.table-wrapper table { min-width: 800px; }
.col-title { max-width: 360px; }
.btn-action {
  display: inline-flex;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #0d9488;
  font-size: 18px;
  text-decoration: none;
}
</style>
